<template>
  <div class="nav-page">
    <span class="page-span prev-page" @click="pagePrevClick">上一页</span>
    <div class="page-div" v-for="(item) in flist" :key="item">
      <span v-if="item == curpage" class="cur-page" >{{curpage}}</span>
      <span v-else class="page-span" :pageno="item" @click="pageClick">{{item}}</span>
    </div>
    <span class="page-span next-page" @click="pageNextClick">下一页</span>
  </div>
</template>

<script>
export default {
  name: "NavPageBox",
  props:{
    total: {
      type: Number,
      default: 20
    },
    curpage:{
      type: Number,
      default: 1
    },
    pagesize:{
      type: Number,
      default: 10
    },
    navsize:{
      type: Number,
      default: 5
    }
  },
  computed:{
    flist: function (){
      let cutpage = this.curpage;
      let navsize = this.navsize;
      let totalPage = Math.ceil(this.total / this.pagesize);
      let startPage = (cutpage % navsize == 0? Math.trunc( cutpage / navsize) - 1: Math.trunc( cutpage / navsize)) * navsize;
      let endPage = startPage + navsize > totalPage? totalPage: startPage + navsize;
      let listPage = [];
      for(let i = startPage + 1 ;i <= endPage; i ++){
        listPage.push(i)
      }
      return listPage
    }
  },

  methods:{
    pageClick: function (e){
      let pageno = e.target.getAttribute('pageno');
      this.$emit("event-page-click", parseInt(pageno));
    },
    pagePrevClick: function (){
      let pageno = this.curpage - 1;
      this.$emit("event-page-click", parseInt(pageno));
    },
    pageNextClick: function (){
      let pageno = this.curpage + 1;
      this.$emit("event-page-click", parseInt(pageno));
    }
  }
}
</script>

<style scoped>
.nav-page{
  text-align: center;
  height: 50px;
  line-height: 50px;
  background-color: #fff;
  color: #000;
}
.page-div{
  display: inline-block;
}

.nav-page .page-span{
  display: inline-block;
  border-radius: 5px;
  height: 26px;
  line-height: 26px;
  margin-left: 5px;
  margin-top: 8px;
  margin-right: 5px;
  padding-left: 10px;
  padding-right: 10px;
  cursor: pointer;
  border: 1px solid #eee;
  background-color: #eee;
  color: #666;
}

.nav-page .page-span:hover{
  border: 1px solid #2e7eee;
  background-color: #2e7eee;
  color: #fff;
}

.cur-page{
  display: inline-block;
  border-radius: 5px;
  height: 26px;
  line-height: 26px;
  margin-left: 5px;
  margin-top: 8px;
  margin-right: 5px;
  padding-left: 10px;
  padding-right: 10px;
  cursor: pointer;
  border: 1px solid #2e7eee;
  background-color: #2e7eee;
  color: #fff;
}

.prev-page:before{
  content: '«';
}
.next-page:after{
  content: '»';
}

</style>
